import React from 'react';
import { Upload, X } from 'lucide-react';

const ImageUploadBox = ({ onImageUpload, currentImage }) => {
  const [isDragging, setIsDragging] = React.useState(false);
  const [previewUrl, setPreviewUrl] = React.useState(null);
  const fileInputRef = React.useRef(null);

  // Handle file selection
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    processFile(file);
  };

  // Process the selected file
  const processFile = (file) => {
    if (!file) return;
    
    // Check file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert('File is too large. Maximum size is 10MB.');
      return;
    }
    
    // Create preview URL
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    
    // Call the parent's handler
    onImageUpload(file);
  };

  // Handle drag events
  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };
  
  const handleDragLeave = () => {
    setIsDragging(false);
  };
  
  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    
    if (event.dataTransfer.files && event.dataTransfer.files[0]) {
      processFile(event.dataTransfer.files[0]);
    }
  };

  // Trigger file input click
  const handleBoxClick = () => {
    fileInputRef.current.click();
  };

  // Remove current image
  const handleRemoveImage = (e) => {
    e.stopPropagation();
    setPreviewUrl(null);
    onImageUpload(null);
  };

  return React.createElement('div', {
    className: `card upload-box ${isDragging ? 'dragging' : ''} animate-slide-up`,
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
    onClick: handleBoxClick,
    style: {
      cursor: 'pointer',
      minHeight: '200px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      position: 'relative'
    }
  },
    !previewUrl && React.createElement(React.Fragment, null,
      React.createElement(Upload, { 
        size: 48,
        className: 'animate-pulse',
        style: { marginBottom: '16px', color: 'var(--secondary)' }
      }),
      React.createElement('h3', { className: 'subtitle' }, 'Upload Your Design'),
      React.createElement('p', null, 'Drag & drop an image or click to browse'),
      React.createElement('p', { style: { fontSize: '0.8rem', opacity: 0.7 } }, 'Maximum file size: 10MB')
    ),
    previewUrl && React.createElement('div', { 
      style: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px'
      }
    },
      React.createElement('div', { 
        style: {
          position: 'relative',
          width: '180px',
          height: '180px'
        }
      },
        React.createElement('img', {
          src: previewUrl,
          alt: 'Preview',
          style: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }
        }),
        React.createElement('button', {
          onClick: handleRemoveImage,
          className: 'button',
          style: {
            position: 'absolute',
            top: '-10px',
            right: '-10px',
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            padding: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        }, React.createElement(X, { size: 16 }))
      ),
      React.createElement('p', null, currentImage ? currentImage.name : '')
    ),
    React.createElement('input', {
      type: 'file',
      accept: 'image/*',
      ref: fileInputRef,
      onChange: handleFileChange,
      style: { display: 'none' }
    })
  );
};

export default ImageUploadBox;